import DeviceServices from "./DeviceServices";

export default DeviceServices;
